var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviceStats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 27,
    viewBox: "0 0 29 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Primary",
    d: "M16.625 2.5C16.625 1.88096 16.119 1.375 15.5 1.375H13.5C12.881 1.375 12.375 1.88096 12.375 2.5V24.5C12.375 25.119 12.881 25.625 13.5 25.625H15.5C16.119 25.625 16.625 25.119 16.625 24.5V2.5ZM10.625 2.5C10.625 0.912786 11.9128 -0.375 13.5 -0.375H15.5C17.0872 -0.375 18.375 0.912786 18.375 2.5V24.5C18.375 26.0872 17.0872 27.375 15.5 27.375H13.5C11.9128 27.375 10.625 26.0872 10.625 24.5V2.5ZM6.625 14.5C6.625 13.881 6.11904 13.375 5.5 13.375H3.5C2.88096 13.375 2.375 13.881 2.375 14.5V24.5C2.375 25.119 2.88096 25.625 3.5 25.625H5.5C6.11904 25.625 6.625 25.119 6.625 24.5V14.5ZM0.625 14.5C0.625 12.9128 1.91279 11.625 3.5 11.625H5.5C7.08721 11.625 8.375 12.9128 8.375 14.5V24.5C8.375 26.0872 7.08721 27.375 5.5 27.375H3.5C1.91279 27.375 0.625 26.0872 0.625 24.5V14.5ZM25.5 5.375H23.5C22.881 5.375 22.375 5.88096 22.375 6.5V24.5C22.375 25.119 22.881 25.625 23.5 25.625H25.5C26.119 25.625 26.625 25.119 26.625 24.5V6.5C26.625 5.88096 26.119 5.375 25.5 5.375ZM20.625 24.5V6.5C20.625 4.91279 21.9128 3.625 23.5 3.625H25.5C27.0872 3.625 28.375 4.91279 28.375 6.5V24.5C28.375 26.0872 27.0872 27.375 25.5 27.375H23.5C21.9128 27.375 20.625 26.0872 20.625 24.5Z",
    fill: "#1964E1",
    stroke: "#C6D2FA",
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceStats);
export default __webpack_public_path__ + "static/media/device-stats.a99550bbdbe420450efc600b438d57af.svg";
export { ForwardRef as ReactComponent };